var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar",style:({
            background: ("#ccc url(" + _vm.styleImage + ") center"),
            backgroundSize: 'cover',
            borderRadius: _vm.styleRadius,
			fontSize:_vm.classIconSize
        })},[(_vm.classIcon && !_vm.hasSlot)?_c('i',{class:_vm.classIcon}):_vm._e(),_c('div',{staticClass:"slot"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }